export const KEYS = {
  LOCALE: 'locale',
  CONFIG: 'config'
}

class GlobalVars {

  constructor () {
    this.store = {}
  }

  clear () {
    this.store = {}
  }

  get (key) {
    return this.store[key]
  }

  remove (key) {
    delete this.store[key]
  }

  set (key, value) {
    this.store[key] = value
  }

}

const globalVars = new GlobalVars()

export default globalVars



// WEBPACK FOOTER //
// ./src/utils/GlobalVars.js